export default "__VITE_ASSET__EQm4kalT__";